var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSfx = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 13,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 0.903,
  d: "m6.018 1.505.648 1.257c.224.435.73.645 1.197.496l1.347-.431-.43 1.347c-.15.466.06.972.495 1.197l1.257.648-1.122.578a1.003 1.003 0 0 0-.434 1.348l1.081 2.112-2.112-1.08a1.003 1.003 0 0 0-1.348.433l-.579 1.122-.647-1.257a1 1 0 0 0-1.198-.496l-1.347.431.431-1.346c.15-.467-.06-.973-.496-1.198L1.504 6.02l1.123-.579c.491-.253.685-.856.433-1.348L1.98 1.98 4.09 3.06a1.003 1.003 0 0 0 1.349-.433z"
})));
export default SvgSfx;